// BonBoZ: nhắc service worker gửi lại các xác nhận thông báo đẩy còn kẹt.
//
// Xác nhận "đã nhận / đã hiện / đã bấm" gửi hỏng thì service worker cất vào
// IndexedDB (xem `public/sw.js`). iOS không có Background Sync, nên trang phải
// tự nhắc vào lúc gần như chắc chắn đã có mạng: khi app mở, và mỗi lần app quay
// lại màn hình.
//
// Chỉ gửi một lời nhắn, không chờ kết quả: thiếu service worker, hoặc trang chưa
// được service worker điều khiển (lần mở đầu tiên), thì bỏ qua — lúc kích hoạt
// service worker cũng tự gửi lại.
export const FLUSH_RECEIPTS_MESSAGE = 'bonboz-flush-receipts';

export const flushPushReceipts = () => {
  try {
    const controller = navigator.serviceWorker?.controller;
    controller?.postMessage({ type: FLUSH_RECEIPTS_MESSAGE });
  } catch {
    // Không có gì để làm: lần mở sau hoặc push sau sẽ gửi lại.
  }
};

// Trả hàm huỷ lắng nghe.
export const listenForPushReceiptFlush = () => {
  flushPushReceipts();
  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') flushPushReceipts();
  };
  document.addEventListener('visibilitychange', onVisibilityChange);
  return () =>
    document.removeEventListener('visibilitychange', onVisibilityChange);
};
